import printApi from '@/api/print.api'
import type { WorksheetExportType } from '@/contentComponents/modal/Download/type'

import type Controller from './Controller'

class PrintController implements Controller {
  adapter = {
    from(data) {
      return data
    },
  }

  async fetchPrintAgentList(teacherId: string) {
    const {
      data: {
        data: { agents },
      },
    } = await printApi.getPrintList(teacherId)
    return agents
  }

  async postMQTTPrintWorksheet(data: req.PrintWorksheet, type?: WorksheetExportType) {
    return await printApi.postMQTTPrintWorksheet(data, type)
  }

  async postMQTTPrintCustomWorkbook(data: req.PrintCustomWorkbook) {
    return await printApi.postMQTTPrintCustomWorkbook(data)
  }

  async postMQTTPrintReport(data: req.PrintReport) {
    return await printApi.postMQTTPrintReport(data)
  }

  async postPrintOneClickReport(data: req.PrintOneClickReport) {
    return await printApi.postPrintOneClickReport(data)
  }

  async postPrintMQTTReportCas(data: req.PrintCasOneClickReport) {
    return await printApi.postPrintMQTTReportCas(data)
  }

  async postMQTTPrintCalculation(data: req.PrintCalculation) {
    return await printApi.postMQTTPrintCalculation(data)
  }

  async postPrintWorkbookQuick(data: req.PrintCustomWorkbook) {
    return await printApi.postPrintCustomWorkbookQuick(data)
  }

  async postMQTTPrintReportRealTime(data: req.PrintReportRealTime) {
    return await printApi.postMQTTPrintReportRealTime(data)
  }
}

export const printController = new PrintController()
